<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="$router.push('/ycpurchaseDemand/add')">发布采购询价</el-button>
      </template>
      <el-form :model="searchForm" inline class="global-form-label-width" label-width="100px">
        <el-form-item label="询价编号"><el-input v-model="searchForm.demandNumber" clearable placeholder="请输入询价编号" /></el-form-item>
        <el-form-item label="询价标题"><el-input v-model="searchForm.demandTitle" clearable placeholder="请输入询价标题" /></el-form-item>
        <el-form-item label="询价状态">
          <el-select v-model="searchForm.demandStatus" clearable placeholder="请选择询价状态">
            <el-option label="报价中" value="1" />
            <el-option label="已完成" value="2" />
            <el-option label="已关闭" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="onSearch">查询</el-button><el-button @click="onReset">重置</el-button></el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table v-loading="loading" :data="tableData" size="mini" stripe border>
        <el-table-column min-width="160" prop="demandNumber" label="询价编号" />
        <el-table-column min-width="180" prop="demandTitle" label="询价标题" show-overflow-tooltip />
        <el-table-column min-width="100" label="询价类型"><template v-slot="{ row }">{{ { '1': '一口价', '2': '暂定价', '3': '通用' }[row.demandType] || '通用' }}</template></el-table-column>
        <el-table-column min-width="150" prop="userName" label="采购方" />
        <el-table-column min-width="180" prop="specName" label="品种规格" show-overflow-tooltip />
        <el-table-column min-width="110" prop="demandQuantity" label="采购数量" />
        <el-table-column min-width="110" prop="expectedPrice" label="期望单价"><template v-slot="{ row }">{{ row.expectedPrice || '--' }}</template></el-table-column>
        <el-table-column min-width="130" prop="quoteDeadline" label="报价截止时间" />
        <el-table-column min-width="90" prop="quoteCount" label="报价数" />
        <el-table-column min-width="90" prop="demandStatus" label="状态">
          <template v-slot="{ row }">
            <el-tag v-if="row.demandStatus === '1'" type="primary">报价中</el-tag>
            <el-tag v-else-if="row.demandStatus === '2'" type="success">已完成</el-tag>
            <el-tag v-else type="info">已关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="150" prop="ctime" label="发布时间" />
        <el-table-column width="260" fixed="right" label="操作">
          <template v-slot="{ row }">
            <el-button type="text" @click="showQuoteList(row)">查看报价</el-button>
            <el-button v-if="row.demandStatus === '1'" type="text" @click="showQuoteAdd(row)">新增报价</el-button>
            <el-button v-if="row.demandStatus === '1'" type="text"
                       @click="$router.push('/ycorderManage/add?demandId=' + row.demandId)">生成采购单</el-button>
            <el-button type="text" @click="$router.push('/ycpurchaseDemand/edit?demandId=' + row.demandId)">编辑</el-button>
            <el-button type="text" class="text-red" @click="deleteDemand(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total" @current-change="loadData" />
    </el-card>

    <el-dialog title="新增报价" :visible.sync="quoteVisible" width="600px" @closed="resetQuoteForm">
      <el-form ref="quoteForm" :model="quoteForm" :rules="quoteRules" label-width="110px">
        <el-form-item label="采购询价"><span>{{ currentDemand.demandNumber }} {{ currentDemand.demandTitle }}</span></el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <el-select v-model="quoteForm.supplierId" filterable placeholder="请选择供应商">
            <el-option v-for="item in supplierList" :key="item.userId" :label="item.userName" :value="item.userId" />
          </el-select>
        </el-form-item>
        <el-form-item label="报价单价" prop="quotePrice"><el-input-number v-model="quoteForm.quotePrice" :min="0.001" :precision="3" /></el-form-item>
        <el-form-item label="可供应数量" prop="quoteQuantity"><el-input-number v-model="quoteForm.quoteQuantity" :min="0.001" :precision="3" /></el-form-item>
        <el-form-item label="报价有效期"><el-date-picker v-model="quoteForm.validUntil" value-format="yyyy-MM-dd" type="date" placeholder="请选择报价有效期" /></el-form-item>
        <el-form-item label="报价说明"><el-input v-model="quoteForm.remark" type="textarea" :rows="3" maxlength="1000" show-word-limit /></el-form-item>
      </el-form>
      <template #footer><el-button @click="quoteVisible = false">取消</el-button><el-button type="primary" @click="submitQuote">保存</el-button></template>
    </el-dialog>

    <el-dialog title="报价明细" :visible.sync="quoteListVisible" width="900px">
      <el-table :data="quoteList" size="mini" stripe border>
        <el-table-column min-width="160" prop="supplierName" label="供应商" />
        <el-table-column min-width="110" prop="quotePrice" label="报价单价" />
        <el-table-column min-width="110" prop="quoteQuantity" label="可供应数量" />
        <el-table-column min-width="120" prop="validUntil" label="有效期" />
        <el-table-column min-width="180" prop="remark" label="报价说明" show-overflow-tooltip />
        <el-table-column min-width="150" prop="ctime" label="报价时间" />
        <el-table-column width="80" label="操作"><template v-slot="{ row }"><el-button type="text" class="text-red" @click="deleteQuote(row)">删除</el-button></template></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PurchaseDemand',
  data() {
    return {
      loading: false,
      page: 1,
      total: 0,
      tableData: [],
      searchForm: { demandNumber: '', demandTitle: '', demandStatus: '' },
      quoteVisible: false,
      quoteListVisible: false,
      currentDemand: {},
      quoteList: [],
      supplierList: [],
      quoteForm: { demandId: '', supplierId: '', quotePrice: undefined, quoteQuantity: undefined, validUntil: '', remark: '' },
      quoteRules: {
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        quotePrice: [{ required: true, message: '请输入报价单价', trigger: 'blur' }],
        quoteQuantity: [{ required: true, message: '请输入可供应数量', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadData()
    this.loadSupplierList()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.yxcPurchaseDemand.selectYxcPurchaseDemandByPage, { ...this.searchForm, page: this.page, size: 10 }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => { this.loading = false })
    },
    loadSupplierList() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, { userType: '4' }).then(res => { this.supplierList = res || [] })
    },
    onSearch() { this.page = 1; this.loadData() },
    onReset() { this.searchForm = { demandNumber: '', demandTitle: '', demandStatus: '' }; this.onSearch() },
    showQuoteAdd(row) { this.currentDemand = row; this.quoteForm.demandId = row.demandId; this.quoteVisible = true },
    showQuoteList(row) { this.currentDemand = row; this.quoteListVisible = true; this.loadQuoteList(row.demandId) },
    loadQuoteList(demandId) {
      this.$axios.get(this.$apis.yxcPurchaseDemand.selectYxcPurchaseQuoteByDemandId, { demandId }).then(res => { this.quoteList = res || [] })
    },
    submitQuote() {
      this.$refs.quoteForm.validate(valid => {
        if (!valid) return
        this.$axios.post(this.$apis.yxcPurchaseDemand.insertYxcPurchaseQuote, this.quoteForm).then(() => {
          this.$message.success('报价新增成功'); this.quoteVisible = false; this.loadData()
        })
      })
    },
    resetQuoteForm() {
      this.quoteForm = { demandId: '', supplierId: '', quotePrice: undefined, quoteQuantity: undefined, validUntil: '', remark: '' }
      if (this.$refs.quoteForm) this.$refs.quoteForm.clearValidate()
    },
    deleteDemand(row) {
      this.$confirm('确认删除该采购询价吗？', '提示', { type: 'warning' }).then(() => {
        this.$axios.post(this.$apis.yxcPurchaseDemand.deleteYxcPurchaseDemand, { demandId: row.demandId }).then(() => {
          this.$message.success('删除成功'); this.loadData()
        })
      }).catch(() => {})
    },
    deleteQuote(row) {
      this.$confirm('确认删除该报价吗？', '提示', { type: 'warning' }).then(() => {
        this.$axios.post(this.$apis.yxcPurchaseDemand.deleteYxcPurchaseQuote, { quoteId: row.quoteId }).then(() => {
          this.$message.success('删除成功'); this.loadQuoteList(this.currentDemand.demandId); this.loadData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-select,
::v-deep .el-input-number,
::v-deep .el-date-editor { width: 100%; }
.text-red { color: #f56c6c; }
</style>
